// Sprint CAL-1c — finestre del calendario: avviso «Hai modifiche non salvate» di CRM-10b (riusato), anche con la ✕ o toccando fuori
import { useRef } from "react";
import { useModificheNonSalvate, useSegnalaModifiche } from "@/pages/crm/crmComuni";

// salva → true se riuscito; chiudi = chiusura della finestra passando dall'avviso se ci sono modifiche
export function useGuardiaFinestra({ sporco, salva, scarta, onChiudi }) {
  const radice = useRef(null);
  const { registra, prosegui, finestra } = useModificheNonSalvate(radice);
  useSegnalaModifiche(registra, "finestra-calendario", sporco, salva, scarta);
  return { radice, chiudi: () => prosegui(onChiudi), finestra };
}
